import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Font,
  Image as PDFImage
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'medium' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    // paddingTop: '5%',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  text: {
    fontSize: 10
  },
  textUnderlined: {
    fontSize: 10,
    textDecoration: 'underline',
    textDecorationColor: 'black',
    textDecorationThickness: 1.5,
    width: '120%'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 5,
    paddingBottom: '3px',
    borderBottom: '1px solid black',
    paddingTop: '130px',
    paddingRight: '30px',
    paddingLeft: '30px'
    // padding: '10px'
  },
  column: {
    width: '33%',
    display: 'flex',
    flexDirection: 'column',
    gap: 1
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 5
  },
  label: {
    fontWeight: 'bold',
    fontSize: 10
  },
  value: {
    fontSize: 10,
    fontWeight: 'normal',
    width: '65%'
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const PatientRegistrationPdf1 = ({ data }) => {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const ageString = data.age;
  const years = ageString.match(/\d+Y/);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`${data.name} Registration`}>
          <Page size="A4" style={styles.page}>
            <PDFImage src="/PDf Print Format.png" style={{ width: '100%', height: '100%' }} />
          </Page>
          <View style={styles.row}>
            <Text content="-      " style={{ ...styles.label, fontFamily: 'Roboto' }} />
          </View>
          <View style={styles.row}>
            <Text
              content="OP SLIP     "
              style={{
                ...styles.label,
                fontFamily: 'Roboto',
                marginLeft: '45%',
                marginTop: '19%',
                textDecoration: 'underline'
              }}
            />
          </View>
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="UHID NO.      : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.uhid}
                  style={{
                    ...styles.value,
                    borderBottom: '1px solid black',
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Name            : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.name}
                  style={{
                    ...styles.value,
                    borderBottom: '1px solid black',
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Guardian      : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data?.guardian_name}
                  style={{
                    ...styles.value,
                    borderBottom: '1px solid black',
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Department : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.department}
                  style={{
                    ...styles.value,
                    borderBottom: '1px solid black',
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Pay Type      : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.pay_type}
                  style={{
                    ...styles.value,
                    borderBottom: '1px solid black',
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Token No.    : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.token_no}
                  style={{
                    ...styles.value,

                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
            </View>

            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="OP No.           :  "
                  style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                />
                <Text
                  content={`${data.op_no}`}
                  style={{
                    ...styles.value,
                    borderBottom: '1px solid black',
                    textAlign: 'start'
                  }}
                />
              </View>
              <View style={{ ...styles.row, marginTop: '2%' }}>
                <Text
                  content="Age/Sex        :  "
                  style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                />
                <Text
                  content={`${data?.age} / ${data.gender}`}
                  style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                />
              </View>

              <View
                style={{
                  ...styles.row,
                  position: 'relative',
                  top: '24%',
                  left: '0.5%'
                }}
              >
                <Text content="Net Paid       :  " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.opd_fee}
                  style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                />
              </View>
              <View
                style={{
                  ...styles.row,
                  position: 'relative',
                  top: '25%',
                  left: '0.5%'
                }}
              >
                <Text content="Mobile No.   : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content={data.mobile} style={{ ...styles.value, textAlign: 'start' }} />
              </View>
            </View>

            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="OP Date            :     " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={formatDate(data?.reg_date)}
                  style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                />
              </View>
              <View style={{ ...styles.row, marginTop: '2%' }}>
                <Text content="Patient Type    :     " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.opd_type}
                  style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                />
              </View>
              <View
                style={{
                  ...styles.row,
                  position: 'relative',
                  top: '26%',
                  left: '0.5%'
                }}
              >
                <Text content="Empanelment  :    " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.sponsor}
                  style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                />
              </View>
              <View
                style={{
                  ...styles.row,
                  position: 'relative',
                  top: '26%',
                  left: '0.5%'
                }}
              >
                <Text content="Doctor Room   :     " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text content={data.doctor_room} style={{ ...styles.value, textAlign: 'start' }} />
              </View>
            </View>
          </View>
          <View
            style={{
              position: 'relative',
              top: -239,
              left: 212,
              flexDirection: 'row', // Make the label and value appear side by side
              alignItems: 'center', // Align text vertically in the center
              marginTop: '10px' // Add margin to space elements from the top
              // width: '50%' // Adjust the width if needed
            }}
          >
            <Text
              content="Address        :"
              style={{
                fontFamily: 'Roboto',
                marginTop: '10px', // Adjust the margin to move the label down slightly
                marginRight: '10px' // Optionally, add margin between label and value
              }}
            />
            <Text
              content={data.address}
              style={{
                flex: 6.5,
                borderBottom: '1px solid black',
                textAlign: 'start',
                marginTop: '12px',
                position: 'relative',
                left: -5,
                maxWidth: '290px' // Set a specific width limit
              }}
            />
          </View>

          <View
            style={{
              position: 'relative',
              top: -258,
              left: 212,
              flexDirection: 'row',
              alignItems: 'center',
              marginTop: '10px',
              width: '80%'
            }}
          >
            <Text
              content="Consultant   :"
              style={{
                fontFamily: 'Roboto',
                marginRight: '10px',
                marginTop: '10px'
              }}
            />
            <Text
              content={data.consultant}
              style={{
                flex: 6.5,
                maxWidth: '290px', // Set a specific width limit
                borderBottom: '1px solid black',
                textAlign: 'start',
                marginTop: '12px',
                position: 'relative',
                left: -5
              }}
            />
          </View>
        </Document>
      </PDFViewer>
    </div>
  );
};

{
  /* <View
              style={{
                position: 'relative',
                top: -586,
                left: 138,
                flexDirection: 'row', // Make the label and value appear side by side
                alignItems: 'center', // Align text vertically in the center
                marginTop: '10px', // Add margin to space elements from the top
                width: '80%' // Adjust the width if needed
              }}
            >
              <Text
                content="Address         :"
                style={{
                  fontFamily: 'Roboto',
                  marginTop: '10px', // Adjust the margin to move the label down slightly
                  marginRight: '10px' // Optionally, add margin between label and value
                }}
              />
              <Text
                content={data.address}
                style={{
                  flex: 6.5,
                  borderBottom: '1px solid black',
                  textAlign: 'start',
                  marginTop: '12px',
                  position: 'relative',
                  left: -5
                }}
              />
            </View>
            <View
              style={{
                position: 'relative',
                top: -600,
                left: 138,
                flexDirection: 'row', // Make the label and value appear side by side
                alignItems: 'center', // Align text vertically in the center
                marginTop: '12px', // Add margin to space elements from the top
                width: '80%' // Adjust the width if needed
              }}
            >
              <Text
                content="Consultant    :"
                style={{
                  fontFamily: 'Roboto',
                  marginRight: '10px', // Space between label and value
                  marginTop: '10px'
                  // Adjust vertical space if necessary
                }}
              />
              <Text
                content={data.consultant}
                style={{
                  flex: 6.5,
                  borderBottom: '1px solid black',
                  textAlign: 'start',
                  marginTop: '12px',
                  position: 'relative',
                  left: -5
                }}
              />
            </View> */
}
{
  /* <View
              style={{
                ...styles,
                width: '80%',
                marginRight: '19%'
              }}
            >
              <View style={{ ...styles.column, border: '1px solid black', padding: '6px' }}>
                <View style={styles.row}>
                  <Text
                    content="RX"
                    style={{ fontSize: 15, textDecoration: 'underline', fontFamily: 'Roboto', marginLeft: '115%' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Facilities"
                    style={{ fontSize: 10, textDecoration: 'underline', fontFamily: 'Roboto' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content=" *ICU/NICU" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Operation Theatre" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Nursery with incubator & Phototherapy" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Immunization" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Ac & Non Ac Pvt. Rooms" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Ultrasound Guided Procedures" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*E.C.G/CT/MRI/X-Ray/DEXA" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Physiotheraphy" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Echocardiography" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Fully Automated Laboratory" style={{ fontSize: 10 }} />
                </View>
                <View style={styles}>
                  <Text content="*Health Plans" style={{ fontSize: 10, marginBottom: 2 }} />
                  <Text content="-individual" style={{ fontSize: 10, marginBottom: 2 }} />
                  <Text content="-corporate" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*24 Hours Pharmacy" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Insurance & TPA"
                    style={{ fontSize: 10, textDecoration: 'underline', fontFamily: 'Roboto' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="*Covered For all Insurance Companies & TPA" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*ECHS Approved" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Govt. Approved De-Addiction Center" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Emergency & Ambulance -24 Hours"
                    style={{ fontSize: 10, textDecoration: 'underline', fontFamily: 'Roboto' }}
                  />
                </View>
                <View style={styles}>
                  <Text content="8054922351" style={{ fontSize: 10, marginBottom: 2 }} />
                  <Text content="8054922340" style={{ fontSize: 10, marginBottom: 2 }} />
                  <Text content="9072690726" style={{ fontSize: 10 }} />
                </View>
              </View>
            </View> */
}
{
  /* <View style={{ ...styles.contentContainer3, position: 'relative' }}>
              <View>
                <Text
                  content={
                    'NOTE:- ANY CONSULTATION CHARGES ARE VALID FOR 5 DAYS (BOTH DAYS INCLUSIVE) (MORNING & EVENING BY APPOINTMENT ONLY :8054922340)'
                  }
                />
              </View>
            </View> */
}
